exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px){.CollapsibleItem{display:none}}.CollapsibleItem__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:32px;padding-left:16px;font-size:13px;letter-spacing:.33px}.CollapsibleItem:nth-child(odd) .CollapsibleItem__header{background-color:#fcfcfc}.CollapsibleItem__iconContainer{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;color:#aaa;font-size:14px}.CollapsibleItem__body,.CollapsibleItem__iconContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-rules-2!./node_modules/postcss-loader/lib??ref--3-rules-3!./node_modules/sass-loader/lib/loader.js??ref--3-rules-4!./src/components/Search/CollapsibleItem/CollapsibleItem.scss
// module id = 1171
// module chunks = 0 1 2 3 4 5 6 7